import { Translate } from "components/common/Translate/Translate";
import { FontSize } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/FontSize/FontSize";
import type { TextBox } from "store/features/memeGenerator/types";
import { Alignment } from "./Alignment/Alignment";
import { ApplyToAll } from "./ApplyToAll/ApplyToAll";
import { Bold } from "./Bold/Bold";
import { CapsLock } from "./CapsLock/CapsLock";
import { Italic } from "./Italic/Italic";
import { Opacity } from "./Opacity/Opacity";
import { Spacing } from "./Spacing/Spacing";
import { Underline } from "./Underline/Underline";

interface ContentProps {
    textBox: TextBox;
}

export const Content = ({ textBox }: ContentProps) => {
    return (
        <div className="flex flex-col gap-6 px-4 py-4 text-black dark:text-white">
            <div className="flex  flex-col gap-2 font-semibold">
                <div>
                    <Translate keyName="font-size" />
                </div>
                <FontSize textBoxId={textBox.id} />
            </div>
            <div className="flex items-center justify-between gap-4">
                <Bold textBox={textBox} />
                <Italic textBox={textBox} />
                <Underline textBox={textBox} />
            </div>
            <Alignment textBox={textBox} />
            <CapsLock id={textBox.id} forceCaps={textBox.forceCaps} />
            <Opacity textBox={textBox} />
            <Spacing textBox={textBox} />
            <ApplyToAll textBoxId={textBox.id} />
        </div>
    );
};
